import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'Los tipos de rutina categorizan el mantenimiento preventivo.',
    'Usá denominaciones que reflejen la política de mantenimiento de tu organización. (PM1 , PM2 , PM3 , X , S , M , L , 250h , 500h , 1000h , etc.)',
    'Este campo se usa para identificar las órdenes de trabajo de mantenimiento.',
  ],
  nextSteps: [
    'Crear Planes de mantenimiento y asignar el tipo de rutina a cada rutina del plan.',
  ],
};

const ConfiguracionTiposRutina = () => (
  <ConfiguracionBase
    apiEndpoint="tipos-rutina"
    titulo="Tipos de Rutina"
    descripcion="Tipos de rutinas de mantenimiento"
    icon="fas fa-calendar-check"
    compact
    help={HELP}
  />
);

export default ConfiguracionTiposRutina;
